export const shoplineApi = {
  get_all_shopline_products: {
      method: 'post',
      api: 'backend/Shopline/get_all_shopline_products'
  },
  locations_list: {
    method: 'post',
    api: 'backend/Shopline/locations_list'
  },
  get_custom_collections: {
    method: 'post',
    api: 'backend/Shopline/custom_collections'
  },
  get_smart_collections: {
    method: 'post',
    api: 'backend/Shopline/smart_collections'
  },
}